import { FC } from "react";

import { ProfilePageLogout } from "./ProfilePageLogout";
import { ProfilePageMainInfo } from "./ProfilePageMainInfo";
import { ProfilePageDocuments } from "./ProfilePageDocuments";

export const ProfilePageContent: FC = () => {
  return (
    <>
      <ProfilePageMainInfo />
      <ProfilePageDocuments />
      <ProfilePageLogout />
    </>
  );
};
